import { render, staticRenderFns } from "./CustomersByProduct.vue?vue&type=template&id=1b31b2bf"
import script from "./CustomersByProduct.vue?vue&type=script&lang=js"
export * from "./CustomersByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports